import { ComponentProps, FC } from 'react';

import HtmlContent from '@telialt/common-html-content/src';
import { Modal } from '@telialt/common-modal/src';
import { DataTest } from '@telialt/utils/src/helpers';

import { FooterButton, HeaderTitle } from './SingleButtonModal.styles';

type Props = Pick<ComponentProps<typeof Modal>, 'onHide' | 'isShown'> & {
    isLoading?: boolean;
    title: string;
    btnText: string;
    cmsContent: string;
} & DataTest;

export const SingleButtonModal: FC<Props> = ({ title, btnText, cmsContent, onHide, isShown, isLoading, dataTest }) => (
    <Modal
        onHide={onHide}
        isShown={isShown}
        header={
            <HeaderTitle tag="h1" variant="title-200">
                {title}
            </HeaderTitle>
        }
        footer={
            <FooterButton type="button" variant="primary" fullWidth={false} disabled={isLoading} onClick={onHide}>
                {btnText}
            </FooterButton>
        }
        dataTest={dataTest}
    >
        <HtmlContent content={cmsContent} />
    </Modal>
);
